/* eslint-disable react/prop-types */

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisH } from "@fortawesome/free-solid-svg-icons";

const EllipsisIcon = () => <FontAwesomeIcon icon={faEllipsisH} />;

export default EllipsisIcon;
